exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Post{margin-top:30px;color:#fff}.Post .Post__box{position:relative;padding:10px;overflow:hidden}.Post .Post__box:before{content:\"\";display:block;padding-top:100%}.Post .Post__box--content{position:absolute;top:0;left:0;bottom:0;right:0;color:#fff;margin:10%}.Post .Post__name{margin-bottom:0}.Post .Post__text{margin:0}.Post .Post__footer{border-top:2px solid #fff;position:absolute;left:0;right:0;bottom:0}.Post .Post__footer .Post__footer--text{margin-top:15px;font-size:16px;font-weight:400}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/components/PostList/Post/Post.less
 ** module id = 177
 ** module chunks = 0
 **/